import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class BHUserSurveyCustom extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'BHUserSurveyCustom'
  // Define default properties here
  static instanceDefaults() {
    return {};
  }
}
const servicePath = 'bh-user-survey-custom';
const servicePlugin = makeServicePlugin({
  Model: BHUserSurveyCustom,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [async (context) => {
      await Promise.all((context.result.data || context.result).map(async item => {
        item.user = await context.app.service('users').get(item.user_id);
        return item;
      }));
      return context;
    }],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin;